// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1J8wl","title":"FrontImage_title__2HI3F"};